import React from 'react';

import Box from '~/common/components/Box';

const DrawerHeader = ({
  children,
  sx,
  ...props
}: Readonly<Pick<React.ComponentProps<typeof Box>, 'children' | 'sx'>>) => {
  return (
    <Box
      component="header"
      {...props}
      sx={{
        ...sx,
        paddingBottom: '0.5rem',
      }}
    >
      {children}
    </Box>
  );
};

export default DrawerHeader;
